import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "./context/LanguageContext";
import { UserAuthProvider } from "./context/UserAuthContext";
import HomePage from "./pages/HomePage";
import ProgramsPage from "./pages/ProgramsPage";
import ReferralsPage from "./pages/ReferralsPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import FAQPage from "./pages/FAQPage";
import ResourcesPage from "./pages/ResourcesPage";
import DonatePage from "./pages/DonatePage";
import CertificatePage from "./pages/CertificatePage";
import AdminDashboard from "./pages/AdminDashboard";
import PartnerAuth from "./pages/PartnerAuth";
import PartnerDashboard from "./pages/PartnerDashboard";
import UserAuth from "./pages/UserAuth";
import UserDashboard from "./pages/UserDashboard";
import CareersPage from "./pages/CareersPage";
import ServicesPage from "./pages/ServicesPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsPage from "./pages/TermsPage";
import PublicDocumentPage from "./pages/PublicDocumentPage";
import VisionPage from "./pages/VisionPage";
import TrainingPage from "./pages/TrainingPage";
import VolunteerPage from "./pages/VolunteerPage";
import FundersPage from "./pages/FundersPage";
import CommunityFairPage from "./pages/CommunityFairPage";
import GetInvolvedPage from "./pages/GetInvolvedPage";
import Layout from "./components/Layout";
import ScrollToTop from "./components/ScrollToTop";
import "@/App.css";

function App() {
  return (
    <LanguageProvider>
      <UserAuthProvider>
        <div className="App">
          <BrowserRouter>
            <ScrollToTop />
            <Routes>
              <Route element={<Layout />}>
                <Route path="/" element={<HomePage />} />
                <Route path="/programs" element={<ProgramsPage />} />
                <Route path="/referrals" element={<ReferralsPage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/faq" element={<FAQPage />} />
                <Route path="/resources" element={<ResourcesPage />} />
                <Route path="/donate" element={<DonatePage />} />
                <Route path="/donate/success" element={<DonatePage />} />
                <Route path="/certificate" element={<CertificatePage />} />
              <Route path="/careers" element={<CareersPage />} />
              <Route path="/services" element={<ServicesPage />} />
              <Route path="/vision" element={<VisionPage />} />
              <Route path="/training" element={<TrainingPage />} />
              <Route path="/get-involved" element={<GetInvolvedPage />} />
              <Route path="/get-involved/volunteer" element={<VolunteerPage />} />
              <Route path="/get-involved/funders" element={<FundersPage />} />
              <Route path="/get-involved/community-fair" element={<CommunityFairPage />} />
              <Route path="/privacy" element={<PrivacyPolicyPage />} />
              <Route path="/terms" element={<TermsPage />} />
              </Route>
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/partner/login" element={<PartnerAuth />} />
              <Route path="/partner" element={<PartnerDashboard />} />
              <Route path="/portal/login" element={<UserAuth />} />
              <Route path="/portal" element={<UserDashboard />} />
              <Route path="/docs/:slug" element={<PublicDocumentPage />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-right" richColors />
        </div>
      </UserAuthProvider>
    </LanguageProvider>
  );
}

export default App;
